/* eslint-disable  jsx-a11y/label-has-associated-control */ 

import React, { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';



const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    basicDetailWrp: {
        margin: '1rem 0 2rem 0',
        padding: '1rem',
        background: '#fff'
    },
    title: {
        fontFamily: 'VodafoneRg-Regular',
        fontSize: '1.25rem',
        margin: '0 0 2rem 0',
        textAlign: 'left',
        color: "#333",
    },
    fieldsetBox: {
        marginBottom: theme.spacing(1),
        border: 0,
        padding: 0,
        background: 'transparent',
        '& label': {
            fontFamily: 'VodafoneRg-bold',
            fontSize: '1rem',
            margin: '0 0 0.5rem 0',
            textAlign: 'left',
            color: "#333",
            display: 'block',
        },
        '& input[type="text"],input[type="date"],select ': {
            fontFamily: 'VodafoneRg-Regular',
            fontSize: '1rem',
            margin: '0 0 0.5rem 0',
            textAlign: 'left',
            color: "#333",
            background: '#fff',
            borderRadius: '4px',
            width: '100%',
            minHeight: '3rem',
            border: '1px solid #333',
            padding: '0.5rem',
            boxSizing: 'border-box',
            height:'48px',
        },
        '& input[type=date]:before': { content: 'none' },
        '& textarea': {
            fontFamily: 'VodafoneRg-Regular',
            fontSize: '1rem',
            margin: '0 0 0.5rem 0',
            textAlign: 'left',
            color: "#333",
            background: '#fff',
            borderRadius: '4px',
            width: '100%',
            minHeight: '8.5rem',
            border: '1px solid #333',
            padding: '0.5rem',
            boxSizing: 'border-box',
            resize: 'none'
        },
  
  
  
    },
    '& input[aria-invalid="true"]': {
        borderColor: 'red',
    },
    error: {
        color: "red",
        fontFamily: 'VodafoneRg-Regular',
        fontSize: '1rem',
        margin: '0 0 0.5rem 0',
    },
    labelname: {
        fontFamily: 'VodafoneRg-bold',
        fontSize: '1rem',
        margin: '0 0 0.5rem 0',
        textAlign: 'left',
        color: "#333",
        display: 'block',
    },
  
    invalid: {
        borderColor: 'red !important',
    },
  
    wrp2cols: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '1rem'
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
  }));
  
const AssignDoubleScorecard = (props) => {
    const classes = useStyles()
    const { ArrayOfObjDoubleScorecard ,ChallengeTemplateId,businessScoreCardTemplateId,handleChildValueOnChangeDBSC,onChangeDropdownSelectValua} = props
  const [assignScorecardId, setAssignScorecardId] = useState("");
  const [flag, setFlag] = useState("");
  const [error, setError] = useState("");


  const handleDropdownChange = (e) => {
    const selectedValue = e.target.value;
    setAssignScorecardId(selectedValue);
    onChangeDropdownSelectValua(selectedValue)
    try {
      if (!selectedValue) {
        throw new Error("Please select a business score card");
      }

      if (!ChallengeTemplateId) {
        throw new Error("ChallengeTemplateId not found in data");
      }

      // Compare selected dropdown value with challengeTemplateId
      if (selectedValue === ChallengeTemplateId.toString()) {
        setFlag("E");
      } else if(selectedValue === businessScoreCardTemplateId){
        setFlag("B");
      }else{
        setFlag("")
      }
      setError("");
    } catch (err) {
      setError(err.message);
      setFlag(""); // Default flag if error occurs
    }
  };

  const ArrayOfObjDoubleScorecardSelectedID = ArrayOfObjDoubleScorecard?.find(template => 
    Number(template.id) === Number(assignScorecardId) 
  );
    useEffect(()=>{
        console.log('render 1st time')
    },[assignScorecardId])

  useEffect(()=>{
   const payload = {
        SelectedScID: assignScorecardId,
        businessSCFlag:flag,
        QuestionJson: ArrayOfObjDoubleScorecardSelectedID?.scoreCardJson?.value
      };
    handleChildValueOnChangeDBSC(payload)
  },[flag])


console.log("assignScorecardId==>", assignScorecardId)

  // Do not render dropdown if businessScoreCardTemplateId is blank
  // if (!businessScoreCardTemplateId || businessScoreCardTemplateId === '') {
  //   return null;
  // }

  return (


    <div>
    
    <fieldset className={classes.fieldsetBox}>
        <label htmlFor='AssignScorecardId'>Select Assign Scorecard to User</label>
        <select
          name="AssignScorecardId"
          id="AssignScorecardId"
          value={assignScorecardId}
          onChange={handleDropdownChange}
        >
          <option value="">Select...</option>
          {ArrayOfObjDoubleScorecard.map(template => (
            <option key={template.id} value={template.id}>
              {template.templateName}
            </option>
          ))}
        </select>
      </fieldset>


      {error && <p style={{ color: "red" }}>{error}</p>}
      {/* <p>Flag: {flag}</p> */}

      {/* <button onClick={handleAssign}>Assign</button> */}
    </div>
  );
};


export default  AssignDoubleScorecard